import { render, staticRenderFns } from "./tab-pane-user.vue?vue&type=template&id=826bfd3c&scoped=true"
import script from "./tab-pane-user.vue?vue&type=script&lang=js"
export * from "./tab-pane-user.vue?vue&type=script&lang=js"
import style0 from "./tab-pane-user.vue?vue&type=style&index=0&id=826bfd3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826bfd3c",
  null
  
)

export default component.exports